'use strict'


$(function() {
    if ($('.js-checkbox-max-4').length) {
        $.each($('.js-checkbox-max-4'), function(item, index) {
            var $checkboxes = $('.js-checkbox-max-4 input[type="checkbox"]', item);
            $checkboxes.on('change', function(event) {
                var checked = $('.js-checkbox-max-4 input[type="checkbox"]:checked', item).length;
                if (checked >= 4) {
                    $('.js-checkbox-max-4 input[type="checkbox"]:not(:checked)', item).attr('disabled', true);
                }
                else {
                    $checkboxes.removeAttr('disabled');
                }
            });

            var checked = $('.js-checkbox-max-4 input[type="checkbox"]:checked', item).length;
            if (checked >= 4) {
                $('.js-checkbox-max-4 input[type="checkbox"]:not(:checked)', item).attr('disabled', true);
            }
            else {
                $checkboxes.removeAttr('disabled');
            }
        });
    }

});